const escapeHtml = (value = '') =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const withContainerTemplate = (innerHtml) => `
  <div style="font-family: Tahoma, Arial, sans-serif; line-height: 1.6; color: #111827; direction: auto; text-align: start;">
    ${innerHtml}
  </div>
`;

const exportElementToPdf = async (element, fileName) => {
  const { default: html2pdf } = await import('html2pdf.js');

  const options = {
    margin: [10, 8, 10, 8],
    filename: fileName,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: { mode: ['css', 'legacy'] },
  };

  await html2pdf().set(options).from(element).save();
};

export const downloadTextAsPdf = async (text = '', fileName = 'answer.pdf') => {
  const safeText = escapeHtml(String(text || '')).replace(/\n/g, '<br/>');
  const wrapper = document.createElement('div');
  wrapper.innerHTML = withContainerTemplate(`<div>${safeText}</div>`);

  await exportElementToPdf(wrapper, fileName);
};

export const downloadHtmlAsPdf = async (html = '', fileName = 'answer-html.pdf') => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = withContainerTemplate(html || '<div></div>');

  await exportElementToPdf(wrapper, fileName);
};

